const withTimeline = ({ startingDate, endingDate }) => prevProject => ({
    ...prevProject,
    startingDate,
    endingDate,
});

export default withTimeline;
